export default __webpack_public_path__ + "static/media/plus-white.1a8d3b8a.svg";